module.exports = __webpack_public_path__ + "media/images/wines/Langhe-Nebbiolo-a4212e51315df68f85c48b8406b4165c.jpg";